export const SERVICE_CAPS_KEYS = {
    ShowInMenu: 'showInMenu',
    ListInHome: 'listInHome',
    InlineNews: 'inlineNews',
    FloatingNews: 'floatingNews',
    Rss: 'rss',
    Sitemap: 'sitemap',
}
export const SERVICE_CAPS = [
    {
        label: 'نمایش در منو',
        name: SERVICE_CAPS_KEYS.ShowInMenu,
        color: '',
    },
    {
        label: 'لیست خبرها در صفحه اصلی',
        name: SERVICE_CAPS_KEYS.ListInHome,
        color: '',
    },
    {
        label: 'سرویس میان خبر',
        name: SERVICE_CAPS_KEYS.InlineNews,
        color: '',
    },
    {
        label: 'جایگاه شناور',
        name: SERVICE_CAPS_KEYS.FloatingNews,
        color: '',
    },
    {
        label: 'rss',
        name: SERVICE_CAPS_KEYS.Rss,
        color: '',
    },
    {
        label: 'sitemap',
        name: SERVICE_CAPS_KEYS.Sitemap,
        color: '',
    },
]
